import React, { useRef, useState, useEffect } from 'react'
import { toText, filter_fn } from '../utils.js'
import './uniTable.css'
import icon from '../icons.svg'
import Edit from './Edit'

const rowHeight = 33       // Высота одной строки (в пикселях)
let visibleCount = 20    // Кол-во строк на экране
const maxCount = 300    // Кол-во строк без фільтра
let delta = 0           //Ширина прокрутки

function UniTable({ haveHeader, colsArr, data, currCol, sorting, filter, filtArr, showFilter, clickSort, clickHandle, openHandle, saveHandle, cancelHandle, keyHandle, setFilter = () => { }, tblPos = (d) => { return 0 }, needFocus = () => { return -1 }, isActive = true }) {
  //cols масив обєктів {caption,minWidth,dataId}
  //sorting обєкт {dataId,sort:no/asc/desc}
  const targetRef = useRef()
  const headRef = useRef()
  const filtRef = useRef()
  const bodyRef = useRef()
  const heightRef = useRef()
  //const [scrollTop, setScrollTop] = useState(data.length>maxCount?tblPos():0)
  const [scrollTop, setScrollTop] = useState(tblPos())
  const [isPrinting, setIsPrinting] = useState(false)

  let header = ''
  //let footer=''
  let cols = []
  let colslen = 0
  //let min_width=0
  let savefn = () => { }
  if (saveHandle) savefn = (d) => { saveHandle(d) }
  let cancelfn = cancelHandle
  if (cancelfn === undefined) cancelfn = () => { }
  if (keyHandle === undefined) keyHandle = () => { }

  cols = colsArr
  cols = cols.filter(el => !el.hiden)
  colslen = cols.length

  const need_focus = needFocus(0)
  let need_scroll = false

  let dat = data
  dat = dat.filter(item => !item.hide)
  if (filter !== '' && filter !== undefined) {
    let cur_idx = -1
    if (currCol && currCol.edit) cur_idx = dat.findIndex(item => (currCol.uid && currCol.uid === item.uid) || (!currCol.uid && item.id && currCol.id === item.id))
    dat = dat.filter((item, idx) => { return filter_fn(item, filter) || cur_idx === idx })
  }
  let cur_idx = 0
  if (currCol) cur_idx = dat.findIndex(item => (currCol.uid && currCol.uid === item.uid) || (!currCol.uid && item.id && currCol.id === item.id))
  let dat2 = []
  // Вычисляем индекс строки, с которой начинаем отображение
  let startIndex = Math.floor(scrollTop / rowHeight);
  if (heightRef.current && data.length <= maxCount) {
    let id = 0
    let ttlHei = 0
    for (let i = 0; i < heightRef.current.length; i++) {
      ttlHei += heightRef.current[i]
      if (scrollTop < ttlHei) break
      id++
    }
    startIndex = id
  }
  if (cur_idx < startIndex && need_focus !== -1 && currCol) {
    startIndex = Math.max(cur_idx - 2, 0)
    need_scroll = true
  }
  if (!currCol && need_focus === 1) {
    startIndex = 0
    need_scroll = true
    needFocus()
  }
  // Определяем индекс последней строки, которую нужно отобразить
  const totalRows = dat.length
  let endIndex = Math.min(startIndex + visibleCount + 1, totalRows)
  if (data.length > maxCount && !isPrinting) dat2 = dat.filter((item, idx) => idx >= startIndex && idx < endIndex)
  else { dat2 = dat }
  //якщо треба позиціонувати, перевіряємо чи попадає рядок в діапазон і міняємо
  if (cur_idx > endIndex && need_focus !== -1) {
    let endIndex = Math.min(cur_idx + 3, totalRows)
    startIndex = Math.max(endIndex - visibleCount, 0)
    need_scroll = true
  } else {

  }
  if (need_scroll) {
    tblPos(startIndex * rowHeight)
    if (bodyRef.current) bodyRef.current.scrollTop = startIndex * rowHeight
  }

  function countHeight(el, i) {
    if (!el) return
    if (heightRef.current) heightRef.current[i] = el.offsetHeight
    else heightRef.current = [el.offsetHeight]
  }

  function setFocus(el) {
    if (!el) return
    //heightRef.current+=el.
    const need_focus = needFocus()
    if (need_focus === -1) return
    //if(cur_idx<startIndex||cur_idx>endIndex) setScrollTop(cur_idx*rowHeight)
    if (need_focus === -2) {
      if (document.activeElement.nodeName === 'INPUT') return
      el.focus()
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      return
    }
    if (need_focus === 0) {
      if (currCol.edit) {
        if (document.activeElement.nodeName === 'INPUT') return
        const inputs = el.querySelectorAll('input, select')
        if (inputs.length) {
          inputs[0].focus()
          //inputs[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      } else el.focus()
      return
    }
    if (need_focus > el.children.length) return
    const inputs = el.children[need_focus - 1].querySelectorAll('input, select')
    if (inputs.length) inputs[0].focus()
  }

  function tblBlur(e) {
    const el = e.relatedTarget
    if (!el) return
    if (!bodyRef.current) return
    if (bodyRef.current.contains(el)) return
    needFocus(-1)
  }

  const keyClick = (e) => {
    // Глобальний блок клавіш
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End'].includes(e.key)) {
      e.preventDefault();
      e.stopPropagation();
    }
    let pref = ''
    if (e.shiftKey) pref += 'shift_'
    if (e.ctrlKey) pref += 'ctrl_'
    if (e.altKey) pref += 'alt_'
    if (e.key === 'ArrowUp') { lastItem() }
    else if (e.key === 'ArrowDown') { nextItem() }
    else if (e.key === 'PageDown') { next10Item() }
    else if (e.key === 'PageUp') { last10Item() }
    else if (e.key === 'Home') { firstItem() }
    else if (e.key === 'End') { endItem() }
    else keyHandle(pref + e.key)
  }

  //let is_edit=false
  let items = dat2.map((item, idx) => {
    const clickFn = () => { clickHandle(item) }
    const enterFn = (e) => { if (e.key === 'Enter') { e.stopPropagation(); setTimeout(openHandle, 150) } }
    if (currCol && ((currCol.uid && currCol.uid === item.uid) || (!currCol.uid && item.id && currCol.id === item.id))) {
      if (currCol.edit) {
        //is_edit=true
        const enterfn = () => {
          if (document.activeElement.nodeName === 'INPUT' || document.activeElement.nodeName === 'SELECT') {
            const inputs = targetRef.current.querySelectorAll('input')
            const len = inputs.length - 1
            let i = 0
            while (i < len) {
              if (inputs[i++] === document.activeElement) {
                inputs[i].focus()
                for (let k = 0; k < targetRef.current.children.length; k++) {
                  if (targetRef.current.children[k].contains(inputs[i])) needFocus(1 + k)
                }
                return
              }
            }
          }
          savefn(-1)
        }
        return (
          <tr ref={el => { setFocus(el); countHeight(el, idx); targetRef.current = el; return targetRef }} id='editrow' className='selected' tabIndex='0' key={idx} title={item.title || ''} style={{ overflow: 'visible' }}
            onClick={clickFn} onDoubleClick={openHandle} onKeyUp={e => { if (e.key === 'Enter') enterfn() }}>
            {cols.map((col, ind) => {
              let cls = null
              let stl = { minWidth: col.minWidth + 'px', flexGrow: col.minWidth, flexBasis: col.minWidth + 'px', overflow: 'visible' }
              if (col.typeVal === 'submit' || col.caption === 'icon' || col.caption === 'ico') { stl = { width: col.minWidth + 'px', minWidth: col.minWidth - 4 + 'px', textAlign: 'center', paddingLeft: '0' }; cls = 'no-print' }
              else if (col.dataId.substring(0, 3) === 'qtt' || col.dataId.substring(0, 3) === 'prc' || col.dataId.substring(0, 3) === 'sum') stl = { minWidth: col.minWidth + 'px', flexGrow: col.minWidth, flexBasis: col.minWidth + 'px', textAlign: 'right' }
              if (col.maxWidth) stl.maxWidth = col.maxWidth + 'px'
              let td = typeof col.typeVal === 'undefined' ? toText(currCol[col.dataId]) : <Edit Value={currCol[col.dataEdit === undefined ? col.dataId : col.dataEdit]} typeVal={col.typeVal} setVal={col.setFn} />
              //if (ind+1===colslen && col.typeVal) td=<div style={{display:'flex'}}><div style={{width:'calc(100% - 44px)'}}><Edit Value={currCol[col.dataEdit===undefined?col.dataId:col.dataEdit]} typeVal={col.typeVal} setVal={col.setFn} /></div><div onClick={()=>{savefn(-1)}} tabIndex='0' className='smallButton'><img className='ico' src={icon+'#okBut'} alt={''} /></div><div onClick={()=>{cancelfn()}} tabIndex='0' className='smallButton'><img className='ico' src={icon+'#canBut'} alt={''} /></div></div>
              if (ind + 1 === colslen && col.typeVal) td = <div style={{ display: 'flex' }}><div style={{ width: 'calc(100% - 22px)' }}><Edit Value={currCol[col.dataEdit === undefined ? col.dataId : col.dataEdit]} typeVal={col.typeVal} setVal={col.setFn} /></div><div onClick={(e) => { e.stopPropagation(); savefn(-1) }} tabIndex='0' className='smallButton'><img className='ico' src={icon + '#okBut'} alt={''} /></div></div>
              //if (ind+1===colslen && col.typeVal) td=<Edit Value={currCol[col.dataEdit===undefined?col.dataId:col.dataEdit]} typeVal={col.typeVal} setVal={col.setFn} />
              //else if (ind+1===colslen) td=<div style={{display:'flex'}}><div style={{width:'calc(100% - 44px)'}}>{toText(currCol[col.dataId])}</div><div onClick={()=>{savefn(-1)}} tabIndex='0' className='smallButton'><img className='ico' src={icon+'#okBut'} alt={''} /></div><div onClick={()=>{cancelfn()}} tabIndex='0' className='smallButton'><img className='ico' src={icon+'#canBut'} alt={''} /></div></div>
              else if (ind + 1 === colslen) td = <div style={{ display: 'flex' }}><div style={{ width: 'calc(100% - 22px)' }}>{toText(currCol[col.dataId])}</div><div onClick={(e) => { e.stopPropagation(); savefn(-1) }} tabIndex='0' className='smallButton'><img className='ico' src={icon + '#okBut'} alt={''} /></div></div>
              //else if (ind+1===colslen) td=toText(currCol[col.dataId])
              else if (col.caption === 'icon') td = <img className='ico' src={icon + '#' + col.dataId + (item.marked === '1' ? 'Del' : item.posted === '1' ? 'Pst' : '')} alt={''} />
              else if (col.caption === '№') td = idx + 1 + (data.length > maxCount ? startIndex : 0)//+cur_idx-visibleCount
              //if (ind+1===colslen) stl.minWidth=(parseInt(col.minWidth)+44)+'px'
              if (typeof col.typeVal === 'undefined') stl.overflow = 'hidden'
              if (col.dataId === 'date') stl.whiteSpace = 'nowrap'
              return (
                <td key={col.dataId} style={stl} className={cls} onClick={e => { needFocus(1 + ind) }}>
                  {td}
                </td>)
            })}

          </tr>
        )

      }
      else {
        return (
          <tr ref={el => { setFocus(el); countHeight(el, idx); return targetRef }} className='selected' tabIndex='0' key={idx} title={item.title || ''} onClick={clickFn} onDoubleClick={openHandle} onKeyUp={enterFn}>
            {cols.map((col, ind) => {
              let cls = null
              let an_data = null
              let stl = { minWidth: col.minWidth + 'px', flexGrow: col.minWidth, flexBasis: col.minWidth + 'px' }
              if (col.caption === 'icon' || col.caption === 'ico') { stl = { width: col.minWidth + 'px', minWidth: col.minWidth - 4 + 'px', textAlign: 'center', paddingLeft: '0' }; cls = 'no-print' }
              else if (col.dataId.substring(0, 3) === 'qtt' || col.dataId.substring(0, 3) === 'prc' || col.dataId.substring(0, 3) === 'sum') stl = { minWidth: col.minWidth + 'px', flexGrow: col.minWidth, flexBasis: col.minWidth + 'px', textAlign: 'right' }
              if (col.align) stl.textAlign = col.align
              if (col.analise_data) {
                stl.display = 'flex'
                stl.justifyContent = 'space-between'
                stl.alignItems = 'center'
                if (parseInt(item[col.dataId]) - 1 > parseInt(item[col.analise_data])) an_data = <span style={{ fontSize: '0.7em', color: '#c008', padding: '7px 3px 0 3px' }}>{toText(item[col.analise_data])}&#9650;</span>
                else if (parseInt(item[col.dataId]) + 1 < parseInt(item[col.analise_data])) an_data = <span style={{ fontSize: '0.7em', color: '#0708', padding: '7px 3px 0 3px' }}>{toText(item[col.analise_data])}&#9660;</span>
                else an_data = <span style={{ fontSize: '0.7em', color: '#8888', padding: '7px 3px 0 3px' }}>{toText(item[col.analise_data])}</span>
              }
              if (col.maxWidth) stl.maxWidth = col.maxWidth + 'px'
              if (col.typeCol === 'check') return (<td key={col.dataId} style={stl} className={cls}><input type='checkbox' checked={parseInt(item[col.dataId]) || ''} readOnly={true} /></td>)
              if (col.caption === '№') return (<td key={col.dataId} style={stl} className={cls}>{idx + 1 + (data.length > maxCount && !isPrinting ? startIndex : 0)/*+cur_idx-visibleCount*/}</td>)
              if (col.dataId === 'date') stl.whiteSpace = 'nowrap'
              const td_cont = toText(item[col.dataId])
              return (
                <td key={col.dataId} style={stl} className={cls} title={(td_cont?.length > 20 ? td_cont + "\n" : '') + (item.title || '')}>
                  {an_data}{col.caption === 'icon' ? <img className='ico' src={icon + '#' + col.dataId + (item.marked === '1' ? 'Del' : item.posted === '1' ? 'Pst' : '')} alt={''} /> : td_cont}
                </td>)
            })}

          </tr>
        )

      }
    }
    else {
      return (
        <tr ref={el => { countHeight(el, idx) }} tabIndex='0' style={{ background: item.colour }} key={idx} title={item.title || ''} onClick={clickFn} onDoubleClick={openHandle} onKeyUp={enterFn}>
          {cols.map((col, ind) => {
            let cls = null
            let an_data = null
            let stl = { minWidth: col.minWidth + 'px', flexGrow: col.minWidth, flexBasis: col.minWidth + 'px' }
            if (col.caption === 'icon' || col.caption === 'ico') { stl = { width: col.minWidth + 'px', minWidth: col.minWidth - 4 + 'px', textAlign: 'center', paddingLeft: '0' }; cls = 'no-print' }
            else if (col.dataId.substring(0, 3) === 'qtt' || col.dataId.substring(0, 3) === 'prc' || col.dataId.substring(0, 3) === 'sum') stl = { minWidth: col.minWidth + 'px', flexGrow: col.minWidth, flexBasis: col.minWidth + 'px', textAlign: 'right' }
            if (col.align) stl.textAlign = col.align
            if (col.analise_data) {
              stl.display = 'flex'
              stl.justifyContent = 'space-between'
              stl.alignItems = 'center'
              if (parseInt(item[col.dataId]) > parseInt(item[col.analise_data])) an_data = <span style={{ fontSize: '0.7em', color: '#c008', padding: '7px 3px 0 3px' }}>{toText(item[col.analise_data])}&#9650;</span>
              else if (parseInt(item[col.dataId]) < parseInt(item[col.analise_data])) an_data = <span style={{ fontSize: '0.7em', color: '#0708', padding: '7px 3px 0 3px' }}>{toText(item[col.analise_data])}&#9660;</span>
              else an_data = <span style={{ fontSize: '0.7em', color: '#8888', padding: '7px 3px 0 3px' }}>{toText(item[col.analise_data])}</span>
            }
            if (col.maxWidth) stl.maxWidth = col.maxWidth + 'px'
            if (col.typeCol === 'check') return (<td key={col.dataId} style={stl} className={cls}><input type='checkbox' checked={parseInt(item[col.dataId]) || ''} readOnly={true} /></td>)
            if (col.caption === '№') return (<td key={col.dataId} style={stl} className={cls}>{idx + 1 + (data.length > maxCount && !isPrinting ? startIndex : 0)/*+cur_idx-visibleCount*/}</td>)
            if (col.dataId === 'date') stl.whiteSpace = 'nowrap'
            const td_cont = toText(item[col.dataId])
            return (
              <td key={col.dataId} style={stl} className={cls} title={(td_cont?.length > 20 ? td_cont + "\n" : '') + (item.title || '')} onClick={e => { needFocus(1 + ind) }}>
                {an_data}{col.caption === 'icon' ? <img className='ico' src={icon + '#' + col.dataId + (item.marked === '1' ? 'Del' : item.posted === '1' ? 'Pst' : '')} alt={''} /> : td_cont}
              </td>)
          })}

        </tr>
      )
    }
  })

  if (haveHeader) {
    let colspan = 0
    const hItems = []
    for (let ind = 0; ind < cols.length; ind++) {
      const col = cols[ind]
      let cls = ''
      if (sorting && sorting.dataId === col.dataId) cls = sorting.sort
      // eslint-disable-next-line
      if (col.typeVal === 'submit') savefn = (d) => { col.setFn(d) }
      let stl = { minWidth: col.minWidth + 'px', width: col.minWidth + 'px', flexGrow: col.minWidth, flexBasis: col.minWidth + 'px' }
      if (col.caption === 'icon' || col.caption === 'ico') { stl = { width: col.minWidth + 'px', minWidth: col.minWidth - 4 + 'px', paddingLeft: '0' }; cls += ' no-print' }
      else if (col.dataId.substring(0, 3) === 'qtt' || col.dataId.substring(0, 3) === 'prc' || col.dataId.substring(0, 3) === 'sum') stl = { minWidth: col.minWidth + 'px', width: col.minWidth + 'px', flexGrow: col.minWidth, flexBasis: col.minWidth + 'px' }
      if (col.maxWidth) stl.maxWidth = col.maxWidth + 'px'
      //if (ind+1===colslen&&is_edit) stl.minWidth=(parseInt(col.minWidth)+44)+'px'
      if (showFilter) stl.borderBottom = 'none'
      if (colspan) {
        colspan--
        continue
      }
      colspan = col.colspan || 1
      colspan--
      if (colspan) {
        let minWidth = 0
        let maxWidth = 0
        for (let i = 0; i <= colspan; i++) {
          minWidth += parseInt(cols[ind + i].minWidth)
          maxWidth += parseInt(cols[ind + i].maxWidth) || 0
          if (i) minWidth++
          if (i && maxWidth) maxWidth--
        }
        if (maxWidth) stl.maxWidth = maxWidth + 'px'
        stl.width = minWidth + 'px'
        stl.flexBasis = minWidth + 'px'
        stl.flexGrow = minWidth
        //if (ind+colspan+1>=colslen&&is_edit) minWidth+=44
        stl.minWidth = minWidth + 'px'
      }
      if (col.sortable) {
        hItems.push(
          <th className={cls} key={col.dataId} colSpan={colspan + 1} style={stl} onClick={() => { sortClickHandler(col.dataId) }} title={col.caption === 'icon' || col.caption === 'ico' ? '' : col.caption}>
            {col.caption === 'icon' || col.caption === 'ico' ? '' : col.caption}
          </th>
        )
      } else {
        hItems.push(
          <th className={cls} key={col.dataId} colSpan={colspan + 1} style={stl} title={col.caption === 'icon' || col.caption === 'ico' ? '' : col.caption}>
            {col.caption === 'icon' || col.caption === 'ico' ? '' : col.caption}
          </th>
        )
      }
    }
    let filters = null
    if (showFilter) {
      const currFilter = filter || []
      const colFilter = filtArr || []
      const f_items = cols.map((col, ind) => {
        let cls = ''
        let stl = { minWidth: col.minWidth + 'px', width: col.minWidth + 'px', flexGrow: col.minWidth, flexBasis: col.minWidth + 'px', overflow: 'visible', fontWeight: 'normal', position: 'relative', borderTop: 'none', paddingTop: '0' }
        if (col.caption === 'icon' || col.caption === 'ico') { stl = { width: col.minWidth + 'px', minWidth: col.minWidth - 4 + 'px', paddingLeft: '0', borderTop: 'none' }; cls += ' no-print' }
        if (col.maxWidth) stl.maxWidth = col.maxWidth + 'px'
        if (col.maxWidth && ind + 1 === colslen) stl.maxWidth = (parseInt(col.maxWidth) + delta) + 'px'
        if (delta && ind + 1 === colslen) stl.flexBasis = (parseInt(col.minWidth) + delta) + 'px'
        //if (ind+1===colslen&&is_edit) stl.minWidth=(parseInt(col.minWidth)+44)+'px'
        const item = currFilter.find(el => el.dataId === col.dataId)
        const item2 = colFilter.find(el => el.dataId === col.dataId)
        if (item) {
          if (item.compare === 'lk') {
            //let typeVal=item.typeVal
            //if(item.compare==='in_f'||item.compare==='nin_f') typeVal='fld'+typeVal.substring(3)
            return (<th className={cls} key={col.dataId} style={stl}>
              <input type='text' value={toText(item.value)} onChange={(e) => setFilter(col.dataId, e.target.value, item.typeVal)} style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
              <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '4px', top: '6px', width: '14px', height: '14px', opacity: 0.5 }} />
            </th>)
          } else {
            return (<th className={cls} key={col.dataId} style={stl}>
              <input type='text' value={toText(item.value)} disabled={true} style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
              <img src={icon + '#b955'} alt='' style={{ position: 'absolute', right: '4px', top: '6px', width: '14px', height: '14px', opacity: 0.5 }} />
            </th>)
          }
        } else if (item2) {
          return (<th className={cls} key={col.dataId} style={stl}>
            <input type='text' value={''} onChange={(e) => setFilter(col.dataId, e.target.value, item2.typeVal)} style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
            <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '4px', top: '6px', width: '14px', height: '14px', opacity: 0.5 }} />
          </th>)
        } else return (<th className={cls} key={col.dataId} style={stl}></th>)

      })
      filters = <tr ref={filtRef} style={{ overflow: 'visible' }}>{f_items}</tr>
    }
    header =
      <table className='valueTable' style={{ height: 'auto', marginBottom: '-1px', tableLayout: 'auto' }}><thead><tr ref={headRef}>
        {hItems}
      </tr>{filters}</thead></table>
  }

  const sortClickHandler = (dataId) => {
    let sort = sorting.sort
    if (sorting.dataId === dataId) {
      if (sort === 'no') sort = 'asc'
      else if (sort === 'asc') sort = 'desc'
      else sort = 'asc'
      clickSort(dataId, sort, data)
    }
    else {
      sort = 'asc'
      clickSort(dataId, sort, data)
    }
  }

  let lastItem = () => { }
  let nextItem = () => { }
  let last10Item = () => { }
  let next10Item = () => { }
  let firstItem = () => { }
  let endItem = () => { }
  if (currCol !== undefined) {
    const idx = dat.findIndex(el => (!currCol.uid && currCol.id === el.id) || (currCol.uid && currCol.uid === el.uid))
    if (idx !== -1) {
      if (idx > 0) lastItem = () => { clickHandle({ ...dat[idx - 1] }) }
      if (dat.length - 1 > idx) nextItem = () => { clickHandle({ ...dat[idx + 1] }) }
      if (idx > 29) last10Item = () => { clickHandle({ ...dat[idx - 30] }) }
      else last10Item = () => { clickHandle({ ...dat[0] }) }
      if (dat.length - 30 > idx) next10Item = () => { clickHandle({ ...dat[idx + 30] }) }
      else next10Item = () => { clickHandle({ ...dat[dat.length - 1] }) }
    }
    firstItem = () => { clickHandle({ ...dat[0] }) }
    endItem = () => { clickHandle({ ...dat[dat.length - 1] }) }
  } else if (dat.length > 0) {
    lastItem = () => { clickHandle({ ...dat[0] }) }
    nextItem = () => { clickHandle({ ...dat[0] }) }
    last10Item = () => { clickHandle({ ...dat[0] }) }
    next10Item = () => { clickHandle({ ...dat[0] }) }
    firstItem = () => { clickHandle({ ...dat[0] }) }
    endItem = () => { clickHandle({ ...dat[dat.length - 1] }) }
  }


  const scrl2 = (e) => {
    tblPos(e.target.scrollTop)
        /*if(data.length>maxCount)*/ setScrollTop(e.target.scrollTop)
    needFocus(-1)
  }

  useEffect(() => {
    //обнулити висоту
    //heightRef.current=0

    if (bodyRef.current) {
            /*if(data.length>maxCount)*/ bodyRef.current.scrollTop = tblPos()
      ///*if(data.length>maxCount)*/ visibleCount=bodyRef.current.offsetHeight/rowHeight
      if (bodyRef.current.offsetHeight) visibleCount = bodyRef.current.offsetHeight / rowHeight
      if (bodyRef.current.scrollHeight > bodyRef.current.clientHeight) {
        if (headRef.current) {
          delta = bodyRef.current.offsetWidth - bodyRef.current.lastChild.offsetWidth
          let new_width = parseInt(cols[cols.length - 1].minWidth) + delta
          if (new_width < 0) new_width = 1
          headRef.current.lastChild.style.flexBasis = new_width + 'px'
          if (cols[cols.length - 1].maxWidth) headRef.current.lastChild.style.maxWidth = (parseInt(cols[cols.length - 1].maxWidth) + delta) + 'px'
          if (filtRef.current) {
            filtRef.current.lastChild.style.flexBasis = new_width + 'px'
            if (cols[cols.length - 1].maxWidth) filtRef.current.lastChild.style.maxWidth = (parseInt(cols[cols.length - 1].maxWidth) + delta) + 'px'
          }
        }
      }
    }
    // eslint-disable-next-line 
  }, [data])

  useEffect(() => {
    // Проверяем поддержку matchMedia
    if (!window.matchMedia) return
    const mediaQuery = window.matchMedia('print');
    // Функция-обработчик
    const handleChange = (e) => {
      setIsPrinting(e.matches)     // e.matches будет true, когда браузер переходит в режим печати (или предпросмотра)
    }
    // Устанавливаем начальное значение
    setIsPrinting(mediaQuery.matches)
    // Подписываемся на изменения
    mediaQuery.addEventListener('change', handleChange)
    // Очистка подписки при демонтировании компонента
    return () => { mediaQuery.removeEventListener('change', handleChange) }
  }, [])

  const totalHeight = Math.max(heightRef.current ? heightRef.current.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0, rowHeight * totalRows) + 4

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: '67px',
        overflowY: 'auto',
      }}
      onKeyDown={keyClick}
    >
      {header}
      {/* Контейнер прокрутки */}
      <div
        ref={bodyRef}
        onScroll={scrl2}
        style={{
          //height: `${rowHeight * visibleCount}px`,
          height: '100%',
          overflowY: 'auto',
          border: 'none',
        }}
      >
        {/* Обгортка для скрола */}
        <div style={{ height: totalHeight + 'px', position: 'relative' }}>
          <table className='valueTable' style={{ position: 'absolute', top: `${data.length > maxCount && !isPrinting ? startIndex * rowHeight : 0}px`, marginTop: 0, tableLayout: 'auto' }} onBlur={tblBlur}>
            <tbody>
              {items}
            </tbody>
          </table>
        </div>
      </div>
      {/*footer*/}
    </div>

  )


}

export default UniTable